import * as vp from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavMenu } from '@/providers/NavMenu.provider';
import { AccountTransferRequest } from './types';
import AccountTransferForm from './AccountTransferForm';
import AccountTransferReview from './AccountTransferReview';
import useFetchSubAccounts from '@/hooks/useApi/useFetchSubAccounts';
import { useClientData } from '@/providers/ClientData.provider';
import { UtilButton } from 'UI';
import { useTranslation } from 'react-i18next';

type AccountTransferProps = {
  values: AccountTransferRequest;
  currency: string;
  token: string;
};

const { Box, Title } = vp;

type FC = FunctionComponent;

const AccountTransferContainer: FC = () => {
  const { response } = useClientData();
  const { state: accountTransferState } = useLocation<AccountTransferProps>();
  const tokenProp = accountTransferState?.token;
  const currencyProp = accountTransferState?.currency;
  const [subAccountsResponse, fetchSubAccounts] = useFetchSubAccounts({});
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  useEffect(() => {
    fetchSubAccounts({
      PortalUser: response.AccountID,
      ShowToken: true,
    });
  }, []);

  const { getModuleTitle } = useNavMenu();

  const selectedAccount =
    tokenProp !== undefined
      ? String(
          Object.values(subAccountsResponse.Subaccounts || {}).find((account) => account.Token === tokenProp)
            ?.AccountID || '',
        )
      : '';
  const currency = currencyProp || (response.Country === 'US' ? 'USD' : 'CAD');
  const [isReview, setIsReview] = useState(false);
  const [defaultValues, setDefaultValue] = useState<AccountTransferRequest>(
    accountTransferState?.values
      ? accountTransferState?.values
      : {
          Currency: currency,
          From: selectedAccount,
          To: '',
          Amount: 0.0,
        },
  );

  const handleToken = () => {};

  const handlers = {
    onAccountTransfer: (_values: AccountTransferRequest) => {
      setIsReview(true);
      _values.Amount = Number(String(_values.Amount)?.replaceAll(',', ''));
      setDefaultValue(_values);
    },
  };
  const onBack = () => {
    setIsReview(false);
  };
  return (
    <Box mb="md" jc="sb" flx="col" gap="lg">
      {isReview ? (
        <Box flx="col" mb="md" gapSize="16px">
          <UtilButton
            iconLeft="chevron_left"
            size="large"
            onClick={() => {
              setIsReview(false);
            }}
          >
            {tGlobal('Buttons.back')}
          </UtilButton>
          <Title title="Review and Transfer" />
        </Box>
      ) : (
        <Box mb="md" jc="sb">
          <Title title={getModuleTitle()} />
        </Box>
      )}

      {!isReview && (
        <AccountTransferForm
          defaultValues={defaultValues}
          handleToken={handleToken}
          handlers={handlers}
          subAccounts={subAccountsResponse.Subaccounts || {}}
        />
      )}

      {isReview && (
        <AccountTransferReview
          values={defaultValues}
          subAccounts={subAccountsResponse.Subaccounts || {}}
          onBack={onBack}
        />
      )}
    </Box>
  );
};

export default AccountTransferContainer;
